var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBxlTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bxl-twitter"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M18.301 3.997C18.314 4.172 18.314 4.346 18.314 4.52C18.314 9.845 14.261 15.981 6.85397 15.981C4.57197 15.981 2.45197 15.32 0.667969 14.172C0.991969 14.209 1.30397 14.222 1.64097 14.222C3.52397 14.222 5.25697 13.586 6.64197 12.501C4.87097 12.464 3.38697 11.304 2.87497 9.708C3.12397 9.745 3.37397 9.77 3.63597 9.77C3.99697 9.77 4.35997 9.72 4.69697 9.633C2.84997 9.259 1.46697 7.638 1.46697 5.68V5.63C2.00397 5.929 2.62697 6.116 3.28697 6.141C2.20197 5.419 1.49097 4.184 1.49097 2.787C1.49097 2.039 1.68997 1.353 2.03897 0.754997C4.02197 3.198 7.00297 4.795 10.345 4.97C10.283 4.67 10.245 4.359 10.245 4.047C10.245 1.827 12.041 0.0189972 14.273 0.0189972C15.433 0.0189972 16.48 0.504997 17.216 1.291C18.126 1.116 18.998 0.778997 19.772 0.317997C19.473 1.253 18.836 2.039 18.001 2.538C18.812 2.45 19.598 2.226 20.32 1.914C19.772 2.712 19.087 3.423 18.301 3.997Z",
    fill: "#222222"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxlTwitter);
export default __webpack_public_path__ + "static/media/bxl-twitter.582a6cdf667b715d59a5bc16fedf0594.svg";
export { ForwardRef as ReactComponent };